import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IWaitingForAgent {
  readonly id: string;
  readonly type: MESSAGES.WAITING_FOR_AGENT;
  readonly rm: true;
  readonly role?: string;
}

export const waitingForAgent = (data): IWaitingForAgent => ({
  id: data.id || uuid(),
  type: MESSAGES.WAITING_FOR_AGENT,
  rm: true,
});
